module.exports = __webpack_public_path__ + "img/35.06dd9f0.jpg";